import { all, fork } from 'redux-saga/effects';

import notificationSaga from './notification';

export const rootSaga = function* root() {
  yield all([fork(notificationSaga)]);
};
